var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "texteditor/phonenumber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5546 9.24148L9.78199 7.86949C9.69638 7.80343 9.58962 7.77083 9.48171 7.7778C9.3738 7.78477 9.27213 7.83083 9.19573 7.90735L8.25488 8.84859C8.1848 8.91938 8.09288 8.96444 7.99401 8.97648C7.89513 8.98853 7.79508 8.96685 7.71006 8.91496C7.40713 8.72921 6.90017 8.36929 6.26581 7.73452C5.63145 7.10064 5.2715 6.59327 5.08573 6.29081C5.03378 6.20586 5.0121 6.10582 5.02423 6.00698C5.03636 5.90815 5.08159 5.81633 5.15256 5.74646L6.09341 4.80522C6.17005 4.72887 6.21614 4.62715 6.22303 4.5192C6.22993 4.41124 6.19714 4.30449 6.13083 4.21901L4.7592 2.44611C4.44736 2.04387 3.85933 1.98017 3.47621 2.31648C2.97149 2.75926 2.36519 3.42254 2.18878 4.16689C1.86937 5.5077 2.3741 7.19017 4.59259 9.40853C6.81108 11.6264 8.49366 12.1316 9.83411 11.8126C10.5785 11.6353 11.2423 11.0286 11.6851 10.5244C12.021 10.1413 11.9573 9.5533 11.5546 9.24148Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNode);
export default __webpack_public_path__ + "static/media/phoneNode.b03ea48ec78488075bc205c6227a8ce7.svg";
export { ForwardRef as ReactComponent };